import { Component, OnInit } from '@angular/core';
import { Globals } from '../globals';

@Component({
  selector: 'app-how',
  templateUrl: './how.component.html',
  styleUrls: ['./how.component.css']
})
export class HowComponent implements OnInit {

  theGlobal: any;
  constructor(globals: Globals) {
    this.theGlobal = globals;
  }

  ngOnInit(): void {
    this.loadScripts();
    this.theGlobal.menuLoadder();
    // this used because if the last section paused the audio, 
    // when the section init, pause the audio too, or play, it depends.
    this.theGlobal.switchSound();
  }
  
  loadScripts(){
    const scriptsToLoad = [
      "../assets/js/how/how.js",
    ];

    for(let i = 0; i < scriptsToLoad.length; i++){
      const body = <HTMLDivElement>document.body;
      let divScripts = document.getElementById('personalizedParallax');
      const script = document.createElement('script');
      script.innerHTML = '';
      script.src = scriptsToLoad[i];
      script.async = false;
      script.defer = true;
      divScripts.appendChild(script);
    }
  }

}
